import { BellOff } from "lucide-react";

/**
 * What to do when this site's notifications are blocked: the browser never
 * asks again, so the only way back is its site settings.
 */
export const BrowserDeniedNotice = () => (
  <div className="rounded-lg border border-red-200 bg-red-50 p-4">
    <div className="flex items-center gap-2 text-red-700">
      <BellOff className="h-4 w-4" />
      <span className="text-sm font-medium">Notifications blocked</span>
    </div>
    <p className="text-xs text-red-600 mt-2">
      You've blocked notifications for this site. To enable them:
    </p>
    <ol className="text-xs text-red-600 mt-2 ml-4 list-decimal space-y-1">
      <li>Open your browser's site settings for this page</li>
      <li>Find "Notifications" and change the setting to "Allow"</li>
      <li>Refresh this page</li>
    </ol>
  </div>
);
